module.exports = __webpack_public_path__ + "f314a8a7f552e798683cf11e521dcabe.png";